<script setup>
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

const route = useRoute()
if (!isValidPastUrl(route.params.year, route.params.month, route.params.day)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
useCustomMeta('satelliteDay', `${route.params.year}年`, `${Number(route.params.month)}月`, `${Number(route.params.day)}日`, `/satellite/${route.params.year}/${route.params.month}/${route.params.day}/`)
const breadCrumbList = getBreadCrumb('satellite', 'day', route.params.year, route.params.month, route.params.day)
const time = dayjs.utc(`${route.params.year}${route.params.month}${route.params.day}`, 'YYYYMMDD').unix()
const selectedTime = ref(time)
const { data: satelliteList } = await useFetch('/api/past/satellite/list', { query: { time: time } })
const { data: comment } = await useFetch('/api/past/satellite/comment', { query: { time: time } })
</script>
<template>
  <div>
    <NuxtLayout
      name="satellite"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <PastSatelliteImgViewer
          :img-list="satelliteList"
          :basetime="time"
          @update:time="selectedTime = $event"
        />
      </div>
      <template #main-bottom>
        <div
          v-if="comment[selectedTime]"
          class="info"
        >
          <PastSatelliteComment
            :title="comment[selectedTime].title"
            :body="comment[selectedTime].body"
          />
        </div>
      </template>
    </NuxtLayout>
  </div>
</template>
<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
